import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Shield, Lock, User } from "lucide-react";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AdminLoginPage = () => {
  const navigate = useNavigate();
  const [credentials, setCredentials] = useState({
    username: "",
    password: "",
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(`${API}/admin/login`, credentials);
      localStorage.setItem("admin_token", response.data.token);
      localStorage.setItem("admin_username", response.data.username);
      toast.success("Login effettuato con successo!");
      navigate("/admin/dashboard");
    } catch (error) {
      console.error("Login error:", error);
      toast.error(
        error.response?.data?.detail || "Credenziali non valide"
      );
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setCredentials((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  return (
    <div
      data-testid="admin-login-page"
      className="min-h-screen bg-[#0F172A] flex items-center justify-center px-4"
    >
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="text-center mb-8">
          <img 
            src="https://customer-assets.emergentagent.com/job_volpiano-calcio/artifacts/8nz2bql1_IMG_8381.webp" 
            alt="G.S.D. Volpiano Pianese"
            className="h-24 w-auto mx-auto mb-4 bg-white rounded-xl p-2"
          />
          <h1 className="text-2xl font-bold text-white">Volpianopianese</h1>
          <p className="text-slate-400">Area Amministrazione</p>
        </div>

        {/* Login Form */}
        <form
          onSubmit={handleSubmit}
          className="bg-white rounded-2xl p-8 shadow-2xl"
          data-testid="login-form"
        >
          <h2 className="text-xl font-bold text-slate-900 mb-6">Accedi</h2>

          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-2">
                Username
              </label>
              <div className="relative">
                <User className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-400" />
                <Input
                  type="text"
                  name="username"
                  value={credentials.username}
                  onChange={handleChange}
                  required
                  placeholder="Inserisci username"
                  className="pl-10"
                  data-testid="login-username"
                />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-slate-700 mb-2">
                Password
              </label>
              <div className="relative">
                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-400" />
                <Input
                  type="password"
                  name="password"
                  value={credentials.password}
                  onChange={handleChange}
                  required
                  placeholder="Inserisci password"
                  className="pl-10"
                  data-testid="login-password"
                />
              </div>
            </div>
          </div>

          <Button
            type="submit"
            disabled={loading}
            className="w-full mt-6 bg-[#0047AB] hover:bg-[#003380]"
            data-testid="login-submit"
          >
            {loading ? "Accesso in corso..." : "Accedi"}
          </Button>

          <p className="text-center text-slate-500 text-xs mt-6">
            Accesso riservato agli amministratori del sito
          </p>
        </form>
      </div>
    </div>
  );
};

export default AdminLoginPage;
